import { observer } from 'mobx-react';
import { useMemo } from 'react';

import { Flex, Text } from '@servicetitan/anvil2';
import { useDependencies } from '@servicetitan/react-ioc';

import * as Styles from './breadcrumbs.module.less';
import { getEquipmentLabel } from '../../../equipment-picker/components/search-equipment';
import { MainStore } from '../../stores/main.store';

export const Breadcrumbs = observer(() => {
    const [mainStore] = useDependencies<[MainStore]>(MainStore);

    const items = useMemo(() => {
        const breadcrumbItems = [mainStore.selectedAppointment?.name];
        if (mainStore.selectedEquipmentInfo) {
            breadcrumbItems.push(getEquipmentLabel(mainStore.selectedEquipmentInfo));
        }
        return breadcrumbItems.filter(Boolean);
    }, [mainStore.selectedAppointment, mainStore.selectedEquipmentInfo]);

    if (items.length === 0) {
        return null;
    }

    return (
        <Flex
            direction="row"
            alignItems="center"
            justifyContent="flex-start"
            className={Styles.breadcrumbs}
            data-cy="breadcrumbs"
        >
            <Text className="t-truncate tt-uppercase" size="small">
                {items.join('\u00A0 • \u00A0')}
            </Text>
        </Flex>
    );
});
